export default "__VITE_ASSET__D6X1OwrG__"